import {auth} from "../config/auth";
import {post} from "../utils/api";
import storageService from "./StorageService";
import {parseJwt} from "../utils/token";
import {confirmForgotPassword} from "../store/actions";

export interface TokenResponse {
  access_token: string;
  id_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  expires_at: number;
}

export interface ChallengeRequired {
  challenge: string;
  session: string;
  username: string;
}

export interface User {
  id: string;
  email: string;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
}

class AuthService {
  login(username, password): Promise<TokenResponse | ChallengeRequired> {
    if (!username || !password) {
      return Promise.reject(
        new Error('Email address and password are required')
      );
    }

    return post(`${auth.url}/${auth.clientAppName}/login`, {
      username,
      password,
    });
  }

  respondNewPasswordChallenge(username, newPassword, session): Promise<TokenResponse> {
    return post(`${auth.url}/${auth.clientAppName}/respond-new-password-challenge`, {
      username: username,
      new_password: newPassword,
      session: session
    });
  }

  loadUserFromStorage(): User | null {
    let token = storageService.load("token");
    if (token) {
      let id = parseJwt(token.id_token);
      return {
        id: id["sub"],
        firstName: id["name"],
        lastName: id["family_name"],
        email: id["email"],
        emailVerified: id["email_verified"]
      };
    }
    return null;
  }

  logout() {
    let token = storageService.load("token");
    return post(`${auth.url}/${auth.clientAppName}/sign-out`, {
      access_token: token.access_token
    });
  }

  refreshToken(refreshToken) {
    return post(`${auth.url}/${auth.clientAppName}/refresh-token`, {
      refresh_token: refreshToken
    });
  }

  forgotPassword(username: string) {
    return post(`${auth.url}/${auth.clientAppName}/forgot-password`, {
      username: username
    });
  }

  confirmForgotPassword(username: string, code: string, newPassword: string) {
    return post(`${auth.url}/${auth.clientAppName}/confirm-forgot-password`, {
      username, code, new_password: newPassword
    });
  }
}

export default new AuthService()